import axiosInstance from './axiosInstance';

export async function getLocationDetails(lat, long) {
  try {
    const res = await axiosInstance.get('search/maps/geocode/latlng', {
      params: { lat, lng: long },
    });
    if (res && res.data && res.status === 200) {
      return res;
    }
    return null;
  } catch (e) {
    throw e;
  }
}

export async function getIPLocation() {
  try {
    const res = await axiosInstance.post('search/maps/geolocate');
    if (res && res.data && res.status === 200) {
      return res;
    }
    return null;
  } catch (e) {
    console.error('Error fetching location:', e);
    return null;
  }
}

export async function getLocationByAddress(address) {
  try {
    const res = await axiosInstance.get('search/maps/geocode/address', {
      params: { address },
    });
    if (res && res.data && res.status === 200) {
      return res;
    }
    return null;
  } catch (e) {
    throw e;
  }
}
